
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/snehistorik",
      function () {
        return require("private-next-pages/[region]/[resort]/snehistorik.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/snehistorik"])
      });
    }
  